import { render, staticRenderFns } from "./FaqAnswer.vue?vue&type=template&id=3b786e20&scoped=true&"
import script from "./FaqAnswer.vue?vue&type=script&lang=js&"
export * from "./FaqAnswer.vue?vue&type=script&lang=js&"
import style0 from "./FaqAnswer.vue?vue&type=style&index=0&id=3b786e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b786e20",
  null
  
)

export default component.exports